<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">工资条</div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header">
            <div class="align-items">
              <el-date-picker v-model="query.reportMonth" type="month" value-format="yyyy-MM" placeholder="选择月" @change="totalCounts" :clearable="false"></el-date-picker>
              <div class="ml10 fb">合计 &nbsp;<span class="moneys">￥{{amount}}</span></div>
            </div>
            <el-button type="primary" @click="appeal">申诉</el-button>
          </div>
          <div class="plrb16" v-perm="{key:'salary', value: 'salary:list'}">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名"></el-table-column>
              <el-table-column prop="positionName" label="店员职位" width="auto"></el-table-column>
              <el-table-column prop="reportMonth" width="auto" label="发放月份">
                <template slot-scope="scope">
                  <span>{{formatMonth(scope.row.reportMonth)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="salary" width="auto" label="发放金额">
                <template slot-scope="scope">
                  <span class="moneys">￥{{scope.row.salary}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" width="auto" label="发放状态">
                <template slot-scope="scope">
                  已发放
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" v-perm="{key:'salary', value: 'salary:detail'}" @click="details(scope.row)">查看详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <!-- <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging> -->
          </div>
        </div>
      </div>
    </div>
    <detail ref="detailForm"></detail>
    <wage-appeal ref="wageForm"></wage-appeal>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detail from "./detail.vue";
import wageAppeal from './wageAppeal.vue';
export default {
  data() {
    return {
      url: this.$url.staffSalary.list,
      urlCount: this.$url.attendance.count,
      query: {
        reportMonth: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      list: [],
      amount: 0
    };
  },
  mixins: [minxin],
  components: {detail,wageAppeal},
  computed: {},

  created() {
    // this.query.reportMonth = this.formatMonth(new Date())
    this.query.reportMonth = this.getLastMonth(new Date())
    this.totalCounts();
  },

  methods: {
    details (row) {
      let parmar = {
        reportMonth: this.query.reportMonth,
        staffId: row.staffId
      }
      this.$refs["detailForm"].$emit("set", parmar);
    },
    back() {
      this.$router.push("/dataList/attendancePunch");
    },
    auditBack () {
      this.getData();
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    getSalarySummary () {
        this.amount = 0;
      this.$api.post(this.$url.staffSalary.getSalarySummary, {
        start: this.start,
        reportMonth: this.query.reportMonth
      }).then(res => {
        if (res) {
          this.amount = res;
        }
      });

    },
    totalCounts () {
      this.getData();
      this.getSalarySummary();
    },
    appeal () {
      this.$refs["wageForm"].$emit("set", this.query.reportMonth);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>